import { Text } from '@components/primitives';
import React from 'react';
import styles from './styles';

type BPNominalTitleProps = {
  nominalTitle?: string;
};

const BPNominalTitle: React.FC<BPNominalTitleProps> = ({ nominalTitle = '' }) => (
  <Text testID="nominalTitle" style={styles.nominalHeaderTxtStyles} variant="lg-bold">
    {nominalTitle}:
  </Text>
);

export default BPNominalTitle;
